module.exports = "<navbar></navbar>    \n<router-outlet></router-outlet>"